<template>
  <div class="form-container userform-container">
    <h1>利用者情報の表示</h1>
    <form>
      <table class="info-table">
        <tbody>
          <tr>
            <td><strong>地域</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.region }}</td>
          </tr>
          <tr>
            <td><strong>利用者ID</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.id }}</td>
          </tr>
          <tr>
            <td><strong>部署名</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.departName }}</td>
          </tr>
          <tr>
            <td><strong>メールアドレス</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.mail }}</td>
          </tr>
          <tr>
            <td><strong>利用者氏名（漢字）</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.nameKanji }}</td>
          </tr>
          <tr>
            <td><strong>利用者氏名（カナ）</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.nameKana }}</td>
          </tr>
          <tr>
            <td><strong>郵便番号</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.zip }}</td>
          </tr>
          <tr>
            <td><strong>住所１（市町村まで）</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.zyuusho1 }}</td>
          </tr>
          <tr>
            <td><strong>住所２</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.zyuusho2 }}</td>
          </tr>
          <tr>
            <td><strong>生年月日</strong></td>
            <td><strong>:</strong></td>
            <td>{{ formatDate(userInfo.birth) }}</td>
          </tr>
          <tr>
            <td><strong>性別</strong></td>
            <td><strong>:</strong></td>
            <td>{{ formatGender(userInfo.sex) }}</td>
          </tr>
          <tr>
            <td><strong>固定電話番号</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.tell }}</td>
          </tr>
          <tr>
            <td><strong>スマートフォン番号</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.mobile }}</td>
          </tr>
          <tr>
            <td><strong>備考</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.addNote }}</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/styles/User.css";

export default {
  data() {
    return {
      userInfo: {
        region: "",
        id: "",
        departName: "",
        mail: "",
        nameKanji: "",
        nameKana: "",
        zip: "",
        zyuusho1: "",
        zyuusho2: "",
        birth: "",
        sex: "",
        tell: "",
        mobile: "",
        addNote: "",
      },
    };
  },
  methods: {
    formatGender(data) {
      switch (data) {
        case "0":
          return "不明";
        case "1":
          return "男性";
        case "2":
          return "女性";
        default:
          return "";
      }
    },
    formatDate(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月は0始まり
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}年${month}月${day}日`;
    },
    async getUserDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getDetail`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.userInfo = response.data.data; // APIレスポンスデータを userInfo に格納
        } else {
          alert(`データの取得に失敗しました。ステータスコード: ${response.status}`);
        }
      } catch (error) {
        console.error("エラー詳細:", error.response || error.message);
        alert("タイムアウトです。再ログインしてください。");
      }
    },
  },
  mounted() {
    this.getUserDetails();
  },
};
</script>

<style scoped>
form {
  border: 2px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  max-height: 100vh;
  overflow-y: auto;
}
</style>
